import { render, staticRenderFns } from "./bottomUrl.vue?vue&type=template&id=df477a84&scoped=true"
import script from "./bottomUrl.vue?vue&type=script&lang=js"
export * from "./bottomUrl.vue?vue&type=script&lang=js"
import style0 from "./bottomUrl.vue?vue&type=style&index=0&id=df477a84&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df477a84",
  null
  
)

export default component.exports